export const feedbackTargets = {
  SLIDE: 'SLIDE',
  TEACHER_MANUAL: 'TEACHER_MANUAL',
  EXERCISE: 'EXERCISE',
  WORKING_SHEET: 'WORKING_SHEET',
  LESSON_DOCUMENT: 'LESSON_DOCUMENT',
};
